import actions from './actions'

export default function ProposalFilesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_ProposalFile:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_ProposalFile:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_ProposalFile:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_ProposalFile:
      return {
        ...state,
        editing: { proposalFileID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_ProposalFile_RECIEVED ||
      actions.UPDATE_ProposalFile_RECIEVED ||
      actions.DELETE_ProposalFile_RECIEVED:
      return {
        ...state,
        editing: { proposalFileID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
